import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiServices from "./apiservice";
// import { toast } from "react-toastify";
// import { config } from "../constant";
import Chatapiservices from "./chatapiservices";
const initialState = {
  accessToken: "",
  selectedllm: false,
  isLoading: false,
  isError: false,
  model: {},
  history: [],
  issuccess: false,
  lasthistory: [],
  queryResponse: [],
  allResponses: [],
  clearchat: {},
  connection: false,
  isreselect: false,
  msglike: false,
  balance: [],
  queryerror: {},
  queryError: false,
};

export const Selectedchatbot = createAsyncThunk(
  "selected/llm",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.Selectedllm(user);
      const { data, token } = response;
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const chatlike = createAsyncThunk(
  "chat/like",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.Chatlike(user);
      const { data, token } = response;
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const ModelSelection = createAsyncThunk(
  "model/selection",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.ModelSelected(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const ModelReselect = createAsyncThunk(
  "models/reselct",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.ModelSelection(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const ChatHistory = createAsyncThunk(
  "chat/history",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.Chathistory(user);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const SendChatQuery = createAsyncThunk(
  "chat/query",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.SendQuery(payload);
      return response; // Return the response for fulfilled case
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const Lastchathistory = createAsyncThunk(
  "last/history",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.Lasthistory(payload);
      return response; // Return the response for fulfilled case
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const Balancereminder = createAsyncThunk(
  "balance/chat",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.BalanceReminder(payload);
      return response; // Return the response for fulfilled case
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const Clearchat = createAsyncThunk(
  "clear/chat",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.ClearChat(payload);
      return response; // Return the response for fulfilled case
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const ConnetionHistory = createAsyncThunk(
  "connection/chat",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Chatapiservices.Connetionhistory(payload);
      return response; // Return the response for fulfilled case
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    resetChat: (state) => {
    
      state.selectedllm = false;
      state.lasthistory = [];
      state.queryResponse = [];
      state.allResponses = []; // Reset allResponses
      state.clearchat = {};
      // state.history = [];
      state.queryerror = {};
      state.issuccess = false;
      state.connection = false;
      state.accessToken = "";
    }, 
    setAllResponses: (state, action) => {
      state.allResponses = action.payload; // Set allResponses
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(Selectedchatbot.pending, (state) => {
        state.isLoading = true;
        state.selectedllm = false;
      })
      .addCase(Selectedchatbot.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.accessToken = action.payload;
        state.selectedllm = true;
        state.issuccess = true;
      })
      .addCase(Selectedchatbot.rejected, (state) => {
        state.isLoading = false;
        state.selectedllm = false;
        state.isError = true;
      })

      .addCase(ModelSelection.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(ModelSelection.fulfilled, (state, action) => {
        state.isLoading = false;
        state.model = action.payload;
      })
      .addCase(ModelSelection.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(ChatHistory.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(ChatHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.history = action.payload;
      })
      .addCase(ChatHistory.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(SendChatQuery.pending, (state) => {
        state.isLoading = true;
        state.queryerror = null;
      })
      .addCase(SendChatQuery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.queryResponse = action.payload;
        state.queryerror = null;
        console.log(state.queryResponse, "fff");
      })
      .addCase(SendChatQuery.rejected, (state, action) => {
        state.isLoading = false;
      
        
        if (action.payload?.less_amount) {
          
          state.queryerror = "LessAmountError"; 
        } else if (action.payload?.message === "Not enough tokens.") {
         
          state.queryerror = "TokenError"; 
        } else {
          
          state.queryerror = action.payload;
        
        }
      })
      

      .addCase(Lastchathistory.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(Lastchathistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.lasthistory = action.payload;
        // console.log(state.lasthistory,"ee")
      })
      .addCase(Lastchathistory.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = action.payload;
      })
      .addCase(Clearchat.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(Clearchat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clearchat = action.payload;
        // console.log(state.lasthistory,"ee")
      })
      .addCase(Clearchat.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = action.payload;
      })
      .addCase(ConnetionHistory.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(ConnetionHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.connection = true;
        // console.log(state.lasthistory,"ee")
      })
      .addCase(ConnetionHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = action.payload;
      })
      .addCase(ModelReselect.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(ModelReselect.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isreselect = true;
        // console.log(state.lasthistory,"ee")
      })
      .addCase(ModelReselect.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = action.payload;
      })
      .addCase(chatlike.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(chatlike.fulfilled, (state, action) => {
        state.isLoading = false;
        state.msglike = true;
      })
      .addCase(chatlike.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = true;
      })

      .addCase(Balancereminder.pending, (state) => {
        state.isLoading = true;
        state.queryError = null;
      })
      .addCase(Balancereminder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balance = action.payload;
      })
      .addCase(Balancereminder.rejected, (state, action) => {
        state.isLoading = false;
        state.queryError = true;
      });
  },
});

export const { resetChat,resetstatechat,setAllResponses } = chatSlice.actions;
export default chatSlice.reducer;
